export declare interface TemplateResultClass {
  code: number;
  msg: string;
}

export declare interface pagination {
  pageIndex: number;
  pageSize: number;
  totalCount: number;
}

/**
 * 当前文件请求接口头地址
 */
import http from 'lib//http';

export const urlgetSchoolImportActivityList = '/api/XOrg/Prepare/getSchoolImportActivityList';

export const urlimportActivity = '/api/XOrg/Prepare/importActivity';

export const urlgetActivityInfo = '/api/XOrg/Prepare/getActivityInfo';

export interface IImport{
  code:number;
  msg:string;
  list:{
    Id: string;
    CourseId: string;
    SchoolCourseId: string;
    ActivityName: string;
    ActivityContent: string;
    DocJson: string;
    ActivityRemake: string;
    VoteType: string;
    SelectType: string;
    questionType: string;
    DataJson: string;
    PaperId: string;
    SourceId: string;
    PaperType: string;
    Source: string;
    IsAuditing: string
  }[]
};
export function getSchoolImportActivityList(courseId: string, activityType: number, pageSize?:number,page?:number){
  debugger;
  return http.post<IImport>(urlgetSchoolImportActivityList,{
    courseId,
    activityType,
    pageSize,
    page
  })
};

export function importActivity(ids: string[], courseId: string){
  return http.post<TemplateResultClass>(urlimportActivity,{
    ids,
    courseId
  })
}

export interface IData{
  data:{
    Id: string,
    ActivityName: string,
    ActivityContent: string,
    DocJson: string,
    VoteType: string,
    SelectType: number,
    questionType: number,
    DataJson: string,
    ActivityType: number
  };
  code: number;
  msg: string
}

export function getActivityInfo(id: string){
  return http.post<IData>(urlgetActivityInfo,{
    id
  })
}